<template>
  <div class="logo-area">
    <div class="logo"></div>
    <div class="hospital-info">
      <h1>成都北新医院</h1>
      <p>Chengdu BeiXin Hospital</p>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.logo-area {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo {
  width: 60px;
  height: 60px;
  background-image: url("/Other/hospitalLogo.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.hospital-info h1 {
  margin: 0;
  font-size: 1.3rem;
  color: #1a5fb4;
  text-align: center;
}

.hospital-info p {
  margin: 5px 0 0 0;
  font-size: 0.8rem;
  color: #666;
}
</style>
